export enum CurrencyKind {
  Global = 'global',
  Penalty = 'penalty',
  Permit = 'permit',
}

export enum SpeedUnit {
  KilometersPerHour = 'kilometers per hour',
  MetersPerSecond = 'meters per second',
  MilesPerHour = 'miles per hour',
}

export enum SpeedUnitSymbol {
  KilometersPerHour = 'km/h',
  MetersPerSecond = 'm/s',
  MilesPerHour = 'mph',
}

export enum DistanceUnit {
  Kilometer = 'kilometer',
  Meter = 'meter',
  Mile = 'mile',
}

export enum DistanceUnitSymbol {
  Kilometer = 'km',
  Meter = 'm',
  Mile = 'mi',
}
